// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1HcDd","boxTitle":"Qualiphy_boxTitle__2kTce","box":"Qualiphy_box__2V7bE","toggleWrap":"Qualiphy_toggleWrap__1Dqy4"};